import { useState, useEffect } from "react";
import axios from "axios";
import { useMsal } from "@azure/msal-react";

const useUserInfo = () => {
  const { instance, accounts } = useMsal();
  const [userInfo, setUserInfo] = useState({ displayName: "", jobTitle: "" });

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (accounts.length > 0) {
        try {
          const account = accounts[0];

          // Get azure token
          const response = await instance.acquireTokenSilent({
            scopes: ["User.Read"],
            account: account,
          });

          // Fetch data from GraphAPI
          const graphResponse = await axios.get(
            "https://graph.microsoft.com/v1.0/me",
            {
              headers: {
                Authorization: `Bearer ${response.accessToken}`,
              },
            }
          );

          // Set data
          setUserInfo({
            displayName: graphResponse.data.displayName,
            jobTitle: graphResponse.data.jobTitle,
          });
        } catch (error) {
          console.error("Error fetching user info:", error);
        }
      }
    };

    fetchUserInfo();
  }, [instance, accounts]);

  return { userInfo };
};

export default useUserInfo;
